<template>
  <div class="services-wrapper col-xs-12">
    <hr class="services-upper-line" />
    <div class="col-xs-12 p-0 d-flex flex-direction-column flex-between wrapper-container">
      <div class="col-xs-12 p-0 mb-30 d-flex flex-direction-column pl-15 pr-15">
        <div class="col-xs-12 p-0">
          <div class="col-xs-12 update-members p-0 mb-10">{{ $t('updateTeamMembers')}} </div>
          <div v-if="purchaseDetails" class="col-xs-12 p-0 current-limit"> * {{ $t('currentLimit')}}: {{ purchaseDetails.purchasedLimit}}

          </div>
        </div>
        <div class="col-xs-12 p-0">
          <div class="col-xs-12 p-0 d-flex flex-direction-column pl-19">
            <div>
              <span class="team-members">{{ $t('teamMembers')}} </span><span class="price-free">({{$t('price')}}: {{$t('free')}})</span>
            </div>
            <div class="col-sm-12 col-xs-12 col-md-6 col-md-10 custom-dropdown pl-0" v-if="team_members.length">
                <multiselect class="product-class-ellipsis multiselect-single-dropdown" openDirection="below" :allow-empty="false" :show-labels="false" :searchable="false" :options="team_members"
                  v-model="team_member" track-by="value" label="label" :custom-label="
                    (option) =>
                      team_members.find((x) => x.value === option.value).label || ''
                  " @select="getUserSelectedValue">
                  </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 p-0 footer">
        <div class="col-xs-12 p-0 members">
        <!-- {{ $t('membersValidation')}} -->
        </div>
        <div class="col-xs-12 p-0">
          <hr class="lower-line" />
        </div>
        <div class="col-xs-12 p-0 d-flex flex-between buttons mb-16">
          <div class="col-md-6 col-xs-6 col-sm-6 p-0 footer_left_button d-flex align-center justify-content-start">
            <button type="button" class="btn btn-block blue_outline_back_button" @click="$emit('cancelUpdateAccount')">
            {{ $t('back')}}
            </button>
          </div>
          <div class="col-xs-6 footer_right_buttons_section p-0 d-flex align-center justify-content-end">
            <button type="button" class="btn btn-block blue_outline_cancel_button"
              @click="$emit('cancelUpdateAccount')">
            {{ $t('cancel')}}
            </button>
            <button type="button" class="blue_save_changes_button" @click="upgradeAccount('', 'account')">
            {{ $t('updateAccount')}}
            </button>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <success-modal :successMessage="successMessage" :isTeamMember="true"></success-modal>
    <error-modal :errorMessage="errorMessage" :isTeamMember="true"></error-modal>
    <loader :loadingStatus="loaderStatus"></loader>
    <downgrade-teams-popup :userSelectedValue = "userSelectedValue"
    ></downgrade-teams-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import SuccessModal from '../Common/SuccessModal.vue';
import ErrorModal from '../Common/ErrorModal.vue';
import DowngradeTeamsPopup from '../UIComponents/DowngradeTeamsPopup.vue';
import Loader from '../UIComponents/Loader.vue';
import { getPurchaseDetails } from '../../apis/marketPlace';
import {
  upgradeAccountAddon, getAddonDetails,
} from '../../apis/psm';

export default {
  components: {
    DowngradeTeamsPopup,
    SuccessModal,
    ErrorModal,
    Loader,

  },
  data() {
    return {
      team_member: '',
      team_members: [],
      addonDetails: [],
      successMessage: '',
      teamMember: '',
      loaderStatus: true,
      errorMessage: '',
      userSelectedValue: '',
      purchaseDetails: ''
    };
  },
  props: ['current_utilization', 'roleId'],
  async mounted() {
    await this.getAddonDetails();
    await this.getPurchaseInfo();
    this.setMembersData('add');
  },
  methods: {
    async getPurchaseInfo() {
      const response = await getPurchaseDetails();
      this.purchaseDetails = response.find((item) => item.subscriptionId === 2);
    },
    getUserSelectedValue(value) {
      this.userSelectedValue = value.value;
    },
    openDowngradePopup(value) {
      if (value && (value < this.current_utilization)) {
        $('#downgradeTeamsPopupId').modal({
          backdrop: 'static',
          keyboard: false,
        });
        return true;
      }
      return false;
    },
    setMembersData(type) {
      this.team_members = [];
      if (this.roleId === 1) {
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= this.purchaseDetails.purchasedLimit; i++) {
        // eslint-disable-next-line camelcase
          // const is_disabled = i < this.purchaseDetails.totalLimit;
          // console.log('is', is_disabled);
          this.team_members.push({ label: this.$i18n.locale === 'Portuguese' ? `${i} Membros` : `${i} Members`, value: i });
          // eslint-disable-next-line camelcase
          // if (is_disabled) this.team_members.splice(i, 2);
        }
      } else {
      // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= 50; i++) {
        // eslint-disable-next-line camelcase
        // const is_disabled = i < this.team_member.value;
          if (type === 'add') this.team_members.push({ label: this.$i18n.locale === 'Portuguese' ? `${i} Membros` : `${i} Members`, value: i });
        // eslint-disable-next-line camelcase
        // else if (is_disabled) this.team_members.splice(i - 5, 1, { label: this.$i18n.locale === 'Portuguese' ? `${i} Membros` : `${i} Members`, value: i });
        }
      }
    },
    todayDate() {
      return moment()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(JSON.parse(localStorage.getItem('userData')).account_id);
      const teamIndex = this.addonDetails.findIndex(
        (addon) => addon.units === 'USERS',
      );
      if (teamIndex >= 0) {
        this.teamMember = this.addonDetails[teamIndex];
        this.team_member = { label: `${this.teamMember.total_limit} Members`, value: this.teamMember.total_limit };
        // this.team_member = this.teamMember.total_limit;
        this.loaderStatus = false;
      }
    },
    async upgradeAccount() {
      if (this.teamMember.total_limit === this.team_member.value) {
        this.clearNotifcations();
        this.$notify({
          type: 'warning',
          title: this.$i18n.locale === 'Portuguese' ? 'Aviso' : 'Warning',
          text: this.$i18n.locale === 'Portuguese' ? 'Nenhuma mudança para atualizar!' : 'No change to update!',
          group: 'custom-notification'
        });
        return;
      }
      if (!this.openDowngradePopup(this.userSelectedValue)) {
        this.loaderStatus = true;
        if (this.team_member.value === this.teamMember.currentUtilized) {
          this.loaderStatus = false;
          this.errorMessage = this.$i18n.locale === 'Portuguese' ? 'Por favor, selecione os membros da equipe acima do limite utilizado' : 'Please select team members greater than utilized limit';
          $('#ErrorMsgModal').modal('show');
          return;
        }
        let teamValidUntil;
        if (this.teamMember && this.teamMember.valid_until > this.todayDate() && this.teamMember.total_limit > this.teamMember.default_limit) {
          teamValidUntil = this.teamMember.valid_until;
        } else {
          teamValidUntil = moment
            .utc()
            .add('years', 1)
            .subtract(1, 'days')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        const formData = {
          account_id: JSON.parse(localStorage.getItem('userData')).account_id,
          add_on: [
            {
              account: true,
              active: true,
              id: 1,
              price: 0,
              valid_from: moment(this.teamMember.valid_from).format(
                'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
              ),
              valid_until: moment(teamValidUntil).format(
                'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
              ),
              volume: this.team_member.value,
            },
          ],
          operation: 12,
          payment_mode: 4,
          total_amount: 0,
        };
        const response = await upgradeAccountAddon(formData);
        this.loaderStatus = false;
        if (response.message === 'success' && response.status_code === 200) {
          this.teamMember.total_limit = this.team_member.value;
          await this.getPurchaseInfo();
          this.setMembersData();
          this.successMessage = this.$i18n.locale === 'Portuguese' ? 'A contagem de membros da equipe foi atualizada com sucesso' : 'Team member count has been updated successfully';
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: this.successMessage,
            group: 'custom-notification'
          });
          // $('#successMsgModal').modal({
          //   backdrop: 'static',
          //   keyboard: false,
          // });
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: response.data,
            group: 'custom-notification',
          });
        }
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    closePopup() { },
  },
};
</script>
<style scoped>
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 4px 40px 6px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 1px 40px 4px 0px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.wrapper-container {
  height: calc(85vh - 113px);
  overflow: auto;
  flex-flow: wrap;
  padding: 0px 16px;
}
.price-free {
  color: #146615;
  font-size: 16px;
  font-weight: 700;
}

.pl-19 {
  padding-left: 19px;
}
.update-members {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  padding-left: 4px;
  margin-bottom: 16px;
}

.services-wrapper {
  /* padding-left: 32px; */
  padding: 0px;
}
.wrapper-container::-webkit-scrollbar {
  width: 6px;
}
.wrapper-container::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.wrapper-container::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.wrapper-container::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}

.services-upper-line {
  border-top: 1px solid #D3D3D3;
  opacity: 0.4;
  margin: 16px 0px 26px 0px;
}

.team-members {
  /* padding-top: 26px; */
  font-weight: 400;
  font-size: 16px;
  color: #4D4D4D;
}

/* .multiselect-account {
  margin-left: 40px;
} */

.blue_outline_back_button {
  background-color: #fff;
  border: 1px solid #000001;
  height: 44px;
  width: auto;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  padding: 9px 16px;
}

.footer_right_buttons_section {
  column-gap: 16px;
  background: #ffffff;
}

.blue_outline_cancel_button {
  background-color: #E6E6E6;
  border: none;
  height: 44px;
  width: auto;
  color: #404040;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  padding: 10px 16px;
}

.blue_save_changes_button,
.blue_save_changes_button:hover {
  background-color: #01518a;
  border: none;
  height: 44px;
  min-width: 172px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  margin-top: 0px !important;
  padding: 10px 16px;

}

.members {
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #01518a;
  font-weight: 600;
  padding-left: 9px;
}

.lower-line {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 24px 0px 31px 8px;
  color: #000000;
}

.current-limit {
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 40px;
  color: #333;
  padding-left: 12px;
}

.back-button {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 5px;
  margin-left: 40px;
  margin-top: 23px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
}

.price {
  line-height: 19px;
  color: rgb(137, 181, 132);
}

.col-gap-22 {
  column-gap: 22px;
}

.footer {
  align-self: end;
}
</style>
